const API_URL = process.env.REACT_APP_API_URL;
const CREATE_REPORT_ENDPOINT = process.env.REACT_APP_REPORT_URL;
const xTokenValue = process.env.REACT_APP_X_TOKEN;

export const fetchTranscriptById = async (transcriptId) => {
  try {
    const token = localStorage.getItem('diploAccessKey');
    const response = await fetch(`${API_URL}/${transcriptId}`, {
      method: "GET",
      headers: {
        "x-token": xTokenValue,
'Diplo-Authorization': token,
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch transcript data.");
    }
    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const deleteTranscript = async (transcriptId) => {
  try {
    const token = localStorage.getItem('diploAccessKey');
    const response = await fetch(`${API_URL}/delete/${transcriptId}`, {
      method: "DELETE",
      headers: {
        "x-token": xTokenValue,
'Diplo-Authorization': token,
      },
    });

    const responseData = await response.json();

    if (!response.ok) {
      const errorMessage =
        responseData.message || "Failed to delete the transcript.";
      throw new Error(errorMessage);
    }

    return responseData;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const fetchAllTranscripts = async () => {
  try {
    const token = localStorage.getItem('diploAccessKey');
    const response = await fetch(`${API_URL}`, {
      method: "GET",
      headers: {
        "x-token": xTokenValue,
'Diplo-Authorization': token,
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch transcripts data.");
    }
    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const saveTranscript = async (transcriptId, data) => {
  try {
    const token = localStorage.getItem('diploAccessKey');
    const response = await fetch(`${API_URL}/${transcriptId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-token": xTokenValue,
'Diplo-Authorization': token,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error("Failed to save transcript data.");
    }
    await response.json();
    return true;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const initiateTranscript = async (data) => {
  try {
    const token = localStorage.getItem('diploAccessKey');
    const response = await fetch(`${API_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-token": xTokenValue,
'Diplo-Authorization': token,
      },
      body: JSON.stringify({ ...data, transcript_status: "IN PROGRESS", upload_date: new Date().toString() }),
    });
    if (!response.ok) {
      throw new Error("Failed to initiate transcript.");
    }
    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const createReportForTranscript = async (data) => {
  try {
    const token = localStorage.getItem('diploAccessKey');
    const response = await fetch(`${CREATE_REPORT_ENDPOINT}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-token": xTokenValue,
'Diplo-Authorization': token,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error("Failed to initiate transcript.");
    }
    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};
